"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
exports.subscribe = subscribe;
var SUBSCRIBE = "ms/email/subscribe";
var SUBSCRIBE_SUCCESS = "ms/email/subscribe_success";
var SUBSCRIBE_FAIL = "ms/email/subscribe_fail";

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SUBSCRIBE:
      return {
        subscribing: true
      };

    case SUBSCRIBE_SUCCESS:
      return {
        subscribing: false,
        subscribed: true
      };

    case SUBSCRIBE_FAIL:
      return {
        subscribing: false,
        subscribed: false,
        subscribeError: action.error
      };

    default:
      return state;
  }
}

function subscribe() {
  return {
    types: [SUBSCRIBE, SUBSCRIBE_SUCCESS, SUBSCRIBE_FAIL],
    promise: function promise(client) {
      return client.post("/v1/email/subscribe/hubspot");
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/email.js
// module id = 1005
// module chunks = 0